import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AuthUser } from '~/libs/auth/types';
import { RootState } from '~/redux';

type User = {
  user: AuthUser;
  idToken: string;
  accessToken: string;
  isSessionInitialized: boolean;
};

const userSessionSlice = createSlice({
  name: 'userSession',
  initialState: {} as User,
  reducers: {
    setUserSession: (state, action: PayloadAction<User>) => {
      state.user = action.payload.user;
      state.idToken = action.payload.idToken;
      state.accessToken = action.payload.accessToken;
      state.isSessionInitialized = action.payload.isSessionInitialized;
    },
    clearUserSession: (state) => {
      state.user = {} as AuthUser;
      state.idToken = '';
      state.accessToken = '';
      state.isSessionInitialized = false;
    },
  },
});

export const { setUserSession, clearUserSession } = userSessionSlice.actions;
export const selectIsSessionInitialized = (state: RootState) => state.userSession.isSessionInitialized;
export default userSessionSlice.reducer;
